module.exports = "<a href=\"#\" (click)=\"shareLinkClick($event)\" *ngIf=\"enableShare\">Share</a>\n"